var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.9375H12.8125V5.1625C12.8125 4.88594 12.5891 4.6625 12.3125 4.6625H7.39062L5.55781 2.90937C5.53449 2.88754 5.50382 2.87527 5.47188 2.875H1.5C1.22344 2.875 1 3.09844 1 3.375V12.625C1 12.9016 1.22344 13.125 1.5 13.125H12.4062C12.6094 13.125 12.7937 13.0016 12.8703 12.8125L14.9641 7.625C14.9875 7.56563 15 7.50156 15 7.4375C15 7.16094 14.7766 6.9375 14.5 6.9375ZM11.6875 6.9375H3.71875C3.51562 6.9375 3.33125 7.06094 3.25469 7.25L2.125 10.05V4H5.07031L6.93906 5.7875H11.6875V6.9375Z",
    fill: "#002240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenIcon);
export default __webpack_public_path__ + "static/media/folder-open-icon.0119a821c08058f74649b4301886465b.svg";
export { ForwardRef as ReactComponent };